import { Field, Form } from 'formik'
import { withNamespaces } from '>/i18n'
import bemCx from 'bem-modifiers'
import get from 'lodash/get'

import { Button } from '~/components/Button'
import CheckboxField from '~/components/CheckboxField'
import { Redirect } from '~/components/Link'
import { CONTENT } from './CookieModalContainer'

const GeneralContent = ({ copy = {} }) => <div className='iockeo-modal__content'>
  <div className='iockeo-modal__title'>{copy.title}</div>
  {get(copy, 'list.title') && <p className={bemCx('iockeo-modal__paragraph', 'list-title')}>{copy.list.title}</p>}
  <ol className='iockeo-modal__list'>
    {get(copy, 'list.items', []).map((item, i) =>
      <li className={bemCx('iockeo-modal__paragraph', 'list-item')} key={i}>{item}</li>)}
  </ol>
  <p className='iockeo-modal__paragraph'>{copy.text}</p>
</div>

const DetailedContent = ({ copy = {} }) => <div className='iockeo-modal__content'>
  <div className='iockeo-modal__title'>{copy.title}</div>
  <div className='iockeo-modal__consent'>
    <p className='iockeo-modal__paragraph'>{copy.text}</p>
    <Field
      name='marketing'
      component={CheckboxField}
      label={get(copy, 'marketing.label')}
      modifiers={['auth', 'cookie']}
    />
    {get(copy, 'marketing.text', []).map((paragraph, i) =>
      <p className='iockeo-modal__paragraph' key={i}>{paragraph}</p>
    )}
  </div>
  <div className='iockeo-modal__consent'>
    <Field
      name='functional'
      component={CheckboxField}
      label={get(copy, 'functional.label')}
      disabled
      modifiers={['auth', 'cookie', 'disabled']}
    />
    {get(copy, 'functional.text', []).map((paragraph, i) =>
      <p className={bemCx('iockeo-modal__paragraph', 'disabled')} key={i}>
        {paragraph}
      </p>
    )}
  </div>
</div>

const CookieModalView = ({ content, setContent, privacyPolicyId, t }) => {
  const contentGeneral = content === CONTENT.GENERAL
  const copy = t('cookie', { returnObjects: true }) || {}

  return (
    <Form className={bemCx('iockeo-modal', [content])}>
      {contentGeneral
        ? <GeneralContent copy={copy.general} />
        : <DetailedContent copy={copy.details} />
      }
      <div className='iockeo-modal__section'>
        <Button
          type='submit'
          className='iockeo-modal__button-accept'
          label={copy.button_accept}
        />
        {contentGeneral && <Button
          label={copy.button_manage}
          modifiers={['naked']}
          onClick={() => setContent(CONTENT.DETAILS)}
        />}
        {privacyPolicyId && <div className='iockeo-modal__regulation-info'>
          {copy.privacy_policy_info}
          <Redirect
            route='regulation'
            params={{ id: privacyPolicyId }}
            slug
            target='_blank'
          >
            {copy.privacy_policy_regulation}
          </Redirect>
        </div>}
      </div>
    </Form>
  )
}

export default withNamespaces(['modal'])(CookieModalView)
